import React from 'react';
import BubbleHome from './components/BubbleHome';
import './App.css';

function App() {
  return <BubbleHome />;
}

export default App;
